<header>
  <div class="wrap">
    <div class="text">
      <h2 class="title mr-3">{{ 'popins.fence-base-plate-info.title' | translate }}</h2>
      <p class="mt-3 mb-4">{{ 'popins.fence-base-plate-info.description' | translate }}</p>
    </div>
    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main container-fluid">
  <img class="rounded mx-auto d-block img-fluid" src="assets/img/fence/base-plate.png" alt="kit-angle" />

  <h3 class="text-center mt-3">{{ 'popins.fence-base-plate-info.specifications.title' | translate }}</h3>

  <section class="container">
    <div class="row">
      <p class="col-6">
        <strong>{{ 'popins.fence-base-plate-info.specifications.composition' | translate }}</strong>
      </p>
      <p class="col-6">{{ 'popins.fence-base-plate-info.specifications.composition-value' | translate }}</p>

      <p class="col-6">
        <strong>{{ 'popins.fence-base-plate-info.specifications.color' | translate }}</strong>
      </p>
      <p class="col-6">{{ 'popins.fence-base-plate-info.specifications.color-value' | translate }}</p>

      <p class="col-6">
        <strong>{{ 'popins.fence-base-plate-info.specifications.origin' | translate }}</strong>
      </p>
      <p class="col-6">{{ 'popins.fence-base-plate-info.specifications.origin-value' | translate }}</p>

      <p class="col-6">
        <strong>{{ 'popins.fence-base-plate-info.specifications.dimensions' | translate }}</strong>
      </p>
      <p class="col-6">{{ 'popins.fence-base-plate-info.specifications.dimensions-value' | translate }}</p>

      <p class="col-6">
        <strong>{{ 'popins.fence-base-plate-info.specifications.weight' | translate }}</strong>
      </p>
      <p class="col-6">{{ 'popins.fence-base-plate-info.specifications.weight-value' | translate }}</p>
    </div>
  </section>

  <footer class="popin-footer mt-3">
    <ng-casto-btn
      class="blue"
      [label]="'popins.fence-base-plate-info.confirm' | translate"
      (click)="modalService.close()"></ng-casto-btn>
  </footer>
</div>
